import * as React from "react";
import { SVGProps } from "react";
const SvgInfoSecondary = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M25.282 8.272a1.838 1.838 0 0 0-1.51-1.505C21.022 6.26 18.458 6 16 6c-2.46 0-5.023.26-7.767.766-.797.149-1.366.716-1.514 1.5-.959 5.157-.959 10.407 0 15.464a1.837 1.837 0 0 0 1.51 1.503C10.977 25.74 13.54 26 16 26s5.023-.26 7.767-.766c.797-.149 1.366-.716 1.515-1.506a41.937 41.937 0 0 0 0-15.456Zm1.965-.372a43.934 43.934 0 0 1 0 16.2c-.301 1.6-1.506 2.8-3.113 3.1-2.711.5-5.423.8-8.134.8-2.711 0-5.423-.3-8.134-.8-1.607-.3-2.812-1.5-3.113-3.1-1.004-5.3-1.004-10.8 0-16.2.301-1.6 1.506-2.8 3.113-3.1C10.577 4.3 13.29 4 16 4c2.711 0 5.423.3 8.134.8 1.607.3 2.812 1.5 3.113 3.1ZM17 22c0 .5-.5 1-1 1s-1-.5-1-1v-7c0-.5.5-1 1-1s1 .5 1 1v7Zm-1-10c-.8 0-1.5-.7-1.5-1.5S15.2 9 16 9s1.5.7 1.5 1.5S16.8 12 16 12Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgInfoSecondary;
